import * as ZapparThree from "@zappar/zappar-threejs";
import * as THREE from "three";
import { OBB } from "three/examples/jsm/math/OBB";
import { hideRoarPrompt, revealRoarPrompt } from "../dom";
import { playLaughSound, playRoarSound } from "./videoRecorderAndAudio";
import { playElmoAction } from "./elmo";
import { playUserSuitAction } from "./userSuit";
import { roomShake } from "./room";
import { toggleRoar } from "./roar";

let mouthOpen = false;
let nextIsRoar = false;
let mouthLandmarksEnabled = false;

let lipTopGroup: ZapparThree.FaceLandmarkGroup;
let landmarkTop: THREE.Mesh;
let lipBottomGroup: ZapparThree.FaceLandmarkGroup;
let landmarkBottom: THREE.Mesh;

let mouthHasOpened = false;

export function initMouthLandmarks(
  scene: THREE.Scene,
  camera: ZapparThree.Camera,
  faceTracker: ZapparThree.FaceTracker
) {
  //TOP LIP LANDMARK
  lipTopGroup = new ZapparThree.FaceLandmarkGroup(
    camera,
    faceTracker,
    ZapparThree.FaceLandmarkName.LIP_TOP
  );
  scene.add(lipTopGroup);
  landmarkTop = new THREE.Mesh(
    new THREE.BoxBufferGeometry(0.15, 0.15, 0.15),
    new THREE.MeshBasicMaterial()
  );
  landmarkTop.visible = false;
  lipTopGroup.add(landmarkTop);
  landmarkTop.geometry.computeBoundingBox();
  landmarkTop.geometry.userData.obb = new OBB().fromBox3(
    landmarkTop.geometry.boundingBox as THREE.Box3
  );
  landmarkTop.userData.obb = new OBB();

  //BOTTOM LIP LANDMARK
  lipBottomGroup = new ZapparThree.FaceLandmarkGroup(
    camera,
    faceTracker,
    ZapparThree.FaceLandmarkName.LIP_BOTTOM
  );
  scene.add(lipBottomGroup);
  landmarkBottom = new THREE.Mesh(
    new THREE.BoxBufferGeometry(0.15, 0.15, 0.15),
    new THREE.MeshBasicMaterial()
  );
  landmarkBottom.visible = false;
  landmarkBottom.geometry.computeBoundingBox();
  landmarkBottom.geometry.userData.obb = new OBB().fromBox3(
    landmarkBottom.geometry.boundingBox as THREE.Box3
  );
  landmarkBottom.userData.obb = new OBB();
  lipBottomGroup.add(landmarkBottom);
}

export function checkOpenMouth() {
  if (mouthLandmarksEnabled) {
    if (landmarkTop != null && landmarkBottom != null) {
      landmarkTop?.userData.obb.copy(landmarkTop.geometry.userData.obb);
      landmarkBottom?.userData.obb.copy(landmarkBottom.geometry.userData.obb);
      landmarkTop?.userData.obb.applyMatrix4(landmarkTop.matrixWorld);
      landmarkBottom?.userData.obb.applyMatrix4(landmarkBottom.matrixWorld);

      if (landmarkTop?.userData.obb.intersectsOBB(landmarkBottom?.userData.obb)) {
        if (mouthOpen || mouthOpen == undefined) {
          mouthOpen = false;
          closeMouth();
        }
      } else {
        if (!mouthOpen || mouthOpen == undefined) {
          mouthOpen = true;
          openMouth();
          mouthHasOpened = true;
          hideRoarPrompt();
        }
      }
    }
  }
}

export function openMouth() {
  nextIsRoar = !nextIsRoar;
  if (nextIsRoar) {
    toggleRoar(true)
    playElmoAction("roarAction");
    playUserSuitAction("roarAction");
    playRoarSound();
    roomShake();
    //ADD PHONE VIBRATION HERE
    if (window.navigator.vibrate) window.navigator.vibrate(100);
  } else {
    playLaughSound();
    playElmoAction("laughAction");
    playUserSuitAction("laughAction");
  }
}

export function closeMouth() {
  toggleRoar(false)
}

export function enableMouthLandmarks() {
  mouthLandmarksEnabled = true;
}

export function disableMouthLandmarks() {
  mouthLandmarksEnabled = false;
}

export function checkIfShouldShowRoarPrompt() {
  mouthHasOpened = false;
  setTimeout(() => {
    if (!mouthHasOpened) {
      revealRoarPrompt();
    }
    checkIfShouldShowRoarPrompt();
  }, 10000);
}
